import { render, staticRenderFns } from "./ReferenceForm.vue?vue&type=template&id=21ad82d4"
import script from "./ReferenceForm.vue?vue&type=script&lang=js"
export * from "./ReferenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports